import { render, staticRenderFns } from "./idGener.vue?vue&type=template&id=6ef1a2d3&"
import script from "./idGener.vue?vue&type=script&lang=js&"
export * from "./idGener.vue?vue&type=script&lang=js&"
import style0 from "./idGener.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports